
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountingPeriodDialog extends _Ext.DialogBase<AccountingPeriodRow, any> {
        protected getFormKey() { return AccountingPeriodForm.formKey; }
        protected getIdProperty() { return AccountingPeriodRow.idProperty; }
        protected getLocalTextPrefix() { return AccountingPeriodRow.localTextPrefix; }
        protected getNameProperty() { return AccountingPeriodRow.nameProperty; }
        protected getService() { return AccountingPeriodService.baseUrl; }
        protected getDeletePermission() { return AccountingPeriodRow.deletePermission; }
        protected getInsertPermission() { return AccountingPeriodRow.insertPermission; }
        protected getUpdatePermission() { return AccountingPeriodRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public form = new AccountingPeriodForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.Details);
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initDetailEditor(this, this.form.Details, Config);

        } 
    }
}